import succ1 from "../images/success/1.JPG";
import succ2 from "../images/success/2.JPG";
import succ3 from "../images/success/3.JPG";
import succ4 from "../images/success/4.JPG";
import succ5 from "../images/success/5.JPG";
import succ6 from "../images/success/6.JPG";
import succ7 from "../images/success/7.JPG";
import succ8 from "../images/success/8.JPG";
import succ9 from "../images/success/9.JPG";
import succ10 from "../images/success/10.JPG";
import succ11 from "../images/success/11.JPG";
import succ12 from "../images/success/12.JPG";
import succ13 from "../images/success/13.JPG";

const Amjilt = [
  {
    Id: "1",
    img: succ1,
  },
  {
    Id: "2",
    img: succ2,
  },
  {
    Id: "3",
    img: succ3,
  },
  {
    Id: "4",
    img: succ4,
  },
  {
    Id: "5",
    img: succ5,
  },
  {
    Id: "6",
    img: succ6,
  },
  {
    Id: "7",
    img: succ7,
  },
  {
    Id: "8",
    img: succ8,
  },
  {
    Id: "9",
    img: succ9,
  },
  {
    Id: "10",
    img: succ10,
  },
  {
    Id: "11",
    img: succ11,
  },
  {
    Id: "12",
    img: succ12,
  },
  {
    Id: "13",
    img: succ13,
  },
];

export default Amjilt;
